// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gNavBar {
    background-color:#009dff;
    color:white;
    box-sizing: border-box;
    overflow: hidden;
    box-shadow:0 4px 14px black;
}

.logo {
    padding-left:20px;
    color:white;
    font-weight: 900;
    box-sizing: border-box;
    font-size:24px;
    display:block;
    padding-right:20px;
    padding-bottom:18px;
    background: linear-gradient(138deg, rgba(6,60,131,1) 20%, rgba(0,157,255,1) 58%);
    transition:all .5s;
    height:80px;
    padding-top:20px;
}

.logo:hover {
    /* color:rgb(0, 40, 101); */
    background: linear-gradient(138deg, rgba(36,192,254,1) 20%, rgba(0,157,255,1) 58%);
    text-decoration: underline;
    /* height:84px;
    padding-top:24px; */
}
.navlinks {
    margin:0;
    display:block;
    text-align:center;
    box-sizing: border-box;
    height:70px;
 
    padding:0;
}

.navLinker {
    margin:0;
    display:inline-block;
    line-height:1em;
    font-weight: 900;
    color:white;
    background-color:rgba(32, 57, 112,.5);
    width:50%;
    box-sizing: border-box;
    padding:30px;
}

.navLinker:hover {
    background-color:rgb(17, 41, 96);
    
}



@media only screen and (min-width: 767px) {

    .logo {
        display:inline-block;
        float:left;
        min-width:320px;

    }

    .navlinks {
        display:inline-block;
        float:right;
        width:450px;
    }

    .navLinker {
        border-radius:4px;
        border:2px solid rgb(26, 44, 82);
        padding:24px;
        margin-top:4px;
        width:48%;
        margin-right:4px;
    }
}


.navActive {
    background-color:red;
    background-color:rgb(16, 28, 56);
}`, "",{"version":3,"sources":["webpack://./src/components/navbar.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,gFAAgF;IAChF,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,kFAAkF;IAClF,0BAA0B;IAC1B;uBACmB;AACvB;AACA;IACI,QAAQ;IACR,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;;IAEX,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qCAAqC;IACrC,SAAS;IACT,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gCAAgC;;AAEpC;;;;AAIA;;IAEI;QACI,oBAAoB;QACpB,UAAU;QACV,eAAe;;IAEnB;;IAEA;QACI,oBAAoB;QACpB,WAAW;QACX,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,gCAAgC;QAChC,YAAY;QACZ,cAAc;QACd,SAAS;QACT,gBAAgB;IACpB;AACJ;;;AAGA;IACI,oBAAoB;IACpB,gCAAgC;AACpC","sourcesContent":[".gNavBar {\n    background-color:#009dff;\n    color:white;\n    box-sizing: border-box;\n    overflow: hidden;\n    box-shadow:0 4px 14px black;\n}\n\n.logo {\n    padding-left:20px;\n    color:white;\n    font-weight: 900;\n    box-sizing: border-box;\n    font-size:24px;\n    display:block;\n    padding-right:20px;\n    padding-bottom:18px;\n    background: linear-gradient(138deg, rgba(6,60,131,1) 20%, rgba(0,157,255,1) 58%);\n    transition:all .5s;\n    height:80px;\n    padding-top:20px;\n}\n\n.logo:hover {\n    /* color:rgb(0, 40, 101); */\n    background: linear-gradient(138deg, rgba(36,192,254,1) 20%, rgba(0,157,255,1) 58%);\n    text-decoration: underline;\n    /* height:84px;\n    padding-top:24px; */\n}\n.navlinks {\n    margin:0;\n    display:block;\n    text-align:center;\n    box-sizing: border-box;\n    height:70px;\n \n    padding:0;\n}\n\n.navLinker {\n    margin:0;\n    display:inline-block;\n    line-height:1em;\n    font-weight: 900;\n    color:white;\n    background-color:rgba(32, 57, 112,.5);\n    width:50%;\n    box-sizing: border-box;\n    padding:30px;\n}\n\n.navLinker:hover {\n    background-color:rgb(17, 41, 96);\n    \n}\n\n\n\n@media only screen and (min-width: 767px) {\n\n    .logo {\n        display:inline-block;\n        float:left;\n        min-width:320px;\n\n    }\n\n    .navlinks {\n        display:inline-block;\n        float:right;\n        width:450px;\n    }\n\n    .navLinker {\n        border-radius:4px;\n        border:2px solid rgb(26, 44, 82);\n        padding:24px;\n        margin-top:4px;\n        width:48%;\n        margin-right:4px;\n    }\n}\n\n\n.navActive {\n    background-color:red;\n    background-color:rgb(16, 28, 56);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
